import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=c4ae38c4&scoped=true"
import script from "./EditLink.vue?vue&type=script&lang=js"
export * from "./EditLink.vue?vue&type=script&lang=js"
import style0 from "./EditLink.vue?vue&type=style&index=0&id=c4ae38c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ae38c4",
  null
  
)

export default component.exports